import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  getNotificationsAll,
  getNotificationsError,
  getNotificationsLoading,
  getNotificationsPageNumber,
  isNotificationsLastPage,
} from '@collections/notifications/notifications.selectors';
import { notificationsLoadPage } from '@app/collections/notifications/notifications.actions';
@Component({
  selector: 'mojo-notifications-container',
  templateUrl: './notifications.container.html',
  styleUrls: ['./notifications.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsContainerComponent {
  notifications$ = this.store.select(getNotificationsAll);

  loading$ = this.store.select(getNotificationsLoading);
  pageNumber$ = this.store.select(getNotificationsPageNumber);
  isLast$ = this.store.select(isNotificationsLastPage);
  error$ = this.store.select(getNotificationsError);
  @ViewChild('scrollRef', { static: false }) scroll: ElementRef;

  constructor(private store: Store) {}

  onScroll(page: number) {
    if (
      this.scroll.nativeElement.offsetHeight + this.scroll.nativeElement.scrollTop >=
      this.scroll.nativeElement.scrollHeight
    ) {
      this.store.dispatch(notificationsLoadPage({ apiParams: { page: page + 1 } }));
    }
  }
}
